import { render, staticRenderFns } from "./NewTire.vue?vue&type=template&id=a6f31006"
import script from "./NewTire.vue?vue&type=script&lang=js"
export * from "./NewTire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports